module.exports = __webpack_public_path__ + "0af5d249/img/search-filter-icon.c4751a52.svg";